// Author Lin
// Date 2024-07-04 10:18:21

class SithMesInventoryTransportApplication {
    constructor({
                    id = null,
                    status = '',
                    workOrderCode = '',
                    transType = '',
                    projectCode = '',
                    materialDesc = '',
                    materialCode = '',
                    quantity = '',
                    unit = '',
                    weight = '',
                    length = '',
                    width = '',
                    height = '',
                    detailInformation = '',
                    wbs = '',
                    outsourcePr = '',
                    transReason = '',
                    demandOriginator = '',
                    demandDepartment = '',
                    sourceStation = '',
                    sourceAddr = '',
                    sourcePhone = '',
                    sourceContact = '',
                    destStation = '',
                    destAddr = '',
                    destPhone = '',
                    destContact = '',
                    requiredTime = '',
                    requirePackage = '',
                    transStartTime = '',
                    transCompleteTime = '',
                    vehicleType = '',
                    carNumber = '',
                    tonnage = '',
                    transPr = '',
                    transporter = '',
                    frame = '',
                    transportFrame = '',
                    outdoorType = '',
                    settlementVehicleType = '',
                    prdOrderCode = '',
                    prdOperationCode = '',
                    operationDesc = '',
                    attachment = '',
                    isAsn = '',
                    remark = '',
                    attachmentList = ''
                }
                    = {}) {
        this.id = id;
        this.status = status;
        this.workOrderCode = workOrderCode;
        this.transType = transType;
        this.projectCode = projectCode;
        this.materialDesc = materialDesc;
        this.materialCode = materialCode;
        this.quantity = quantity;
        this.unit = unit;
        this.weight = weight;
        this.length = length;
        this.width = width;
        this.height = height;
        this.detailInformation = detailInformation;
        this.wbs = wbs;
        this.outsourcePr = outsourcePr;
        this.transReason = transReason;
        this.demandOriginator = demandOriginator;
        this.demandDepartment = demandDepartment;
        this.sourceStation = sourceStation;
        this.sourceAddr = sourceAddr;
        this.sourcePhone = sourcePhone;
        this.sourceContact = sourceContact;
        this.destStation = destStation;
        this.destAddr = destAddr;
        this.destPhone = destPhone;
        this.destContact = destContact;
        this.requiredTime = requiredTime;
        this.requirePackage = requirePackage;
        this.transStartTime = transStartTime;
        this.transCompleteTime = transCompleteTime;
        this.vehicleType = vehicleType;
        this.carNumber = carNumber;
        this.tonnage = tonnage;
        this.transPr = transPr;
        this.transporter = transporter;
        this.frame = frame;
        this.transportFrame = transportFrame;
        this.outdoorType = outdoorType;
        this.settlementVehicleType = settlementVehicleType;
        this.prdOrderCode = prdOrderCode;
        this.prdOperationCode = prdOperationCode;
        this.operationDesc = operationDesc;
        this.attachment = attachment;
        this.isAsn = isAsn;
        this.remark = remark;
        this.attachmentList = attachmentList;
    }
}

function newEntity() {
    return new SithMesInventoryTransportApplication();
}

function gridFields() {
    return Object.freeze([
        {
            key: 'id',
            label: 'label.sith.inventory.sithMesInventoryTransportApplication.grid.id',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'status',
            label: 'label.sith.inventory.sithMesInventoryTransportApplication.grid.status',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'workOrderCode',
            label: 'label.sith.inventory.sithMesInventoryTransportApplication.grid.workOrderCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'transType',
            label: 'label.sith.inventory.sithMesInventoryTransportApplication.grid.transType',
            sortable: true,
            form: {
                type: 'select',
                modalMultiSelectedType: 'string'
                , options: [
                    {value: '1', text: '内对外'},
                    {value: '2', text: '内对内'},
                    {value: '3', text: '汽车吊'},
                    {value: '4', text: '外对外'},
                    {value: '5', text: '外对内'}
                ]
            }
        },
        {
            key: 'projectCode',
            label: 'label.sith.inventory.sithMesInventoryTransportApplication.grid.projectCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'materialDesc',
            label: 'label.sith.inventory.sithMesInventoryTransportApplication.grid.materialDesc',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'materialCode',
            label: 'label.sith.inventory.sithMesInventoryTransportApplication.grid.materialCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'quantity',
            label: 'label.sith.inventory.sithMesInventoryTransportApplication.grid.quantity',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'unit',
            label: 'label.sith.inventory.sithMesInventoryTransportApplication.grid.unit',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'weight',
            label: 'label.sith.inventory.sithMesInventoryTransportApplication.grid.weight',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'length',
            label: 'label.sith.inventory.sithMesInventoryTransportApplication.grid.length',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'width',
            label: 'label.sith.inventory.sithMesInventoryTransportApplication.grid.width',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'height',
            label: 'label.sith.inventory.sithMesInventoryTransportApplication.grid.height',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'wbs',
            label: 'label.sith.inventory.sithMesInventoryTransportApplication.grid.wbs',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'outsourcePr',
            label: 'label.sith.inventory.sithMesInventoryTransportApplication.grid.outsourcePr',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'transReason',
            label: 'label.sith.inventory.sithMesInventoryTransportApplication.grid.transReason',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'demandOriginator',
            label: 'label.sith.inventory.sithMesInventoryTransportApplication.grid.demandOriginator',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'demandDepartment',
            label: 'label.sith.inventory.sithMesInventoryTransportApplication.grid.demandDepartment',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'sourceStation',
            label: 'label.sith.inventory.sithMesInventoryTransportApplication.grid.sourceStation',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'sourceAddr',
            label: 'label.sith.inventory.sithMesInventoryTransportApplication.grid.sourceAddr',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'sourcePhone',
            label: 'label.sith.inventory.sithMesInventoryTransportApplication.grid.sourcePhone',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'sourceContact',
            label: 'label.sith.inventory.sithMesInventoryTransportApplication.grid.sourceContact',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'destStation',
            label: 'label.sith.inventory.sithMesInventoryTransportApplication.grid.destStation',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'destAddr',
            label: 'label.sith.inventory.sithMesInventoryTransportApplication.grid.destAddr',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'destPhone',
            label: 'label.sith.inventory.sithMesInventoryTransportApplication.grid.destPhone',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'destContact',
            label: 'label.sith.inventory.sithMesInventoryTransportApplication.grid.destContact',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'requiredTime',
            label: 'label.sith.inventory.sithMesInventoryTransportApplication.grid.requiredTime',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'requirePackage',
            label: 'label.sith.inventory.sithMesInventoryTransportApplication.grid.requirePackage',
            sortable: true,
            form: {
                type: 'boolean',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'transStartTime',
            label: 'label.sith.inventory.sithMesInventoryTransportApplication.grid.transStartTime',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'transCompleteTime',
            label: 'label.sith.inventory.sithMesInventoryTransportApplication.grid.transCompleteTime',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'vehicleType',
            label: 'label.sith.inventory.sithMesInventoryTransportApplication.grid.vehicleType',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'settlementVehicleType',
            label: 'label.sith.inventory.sithMesInventoryTransportApplication.grid.settlementVehicleType',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'carNumber',
            label: 'label.sith.inventory.sithMesInventoryTransportApplication.grid.carNumber',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'tonnage',
            label: 'label.sith.inventory.sithMesInventoryTransportApplication.grid.tonnage',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'transPr',
            label: 'label.sith.inventory.sithMesInventoryTransportApplication.grid.transPr',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'transporter',
            label: 'label.sith.inventory.sithMesInventoryTransportApplication.grid.transporter',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'frame',
            label: 'label.sith.inventory.sithMesInventoryTransportApplication.grid.frame',
            sortable: true,
            form: {
                type: 'select',
                modalMultiSelectedType: 'string'
                , options: [
                    {value: '1', text: '框架内'},
                    {value: '2', text: '框架外'}
                ]
            }
        },
        {
            key: 'director',
            label: 'label.sith.inventory.sithMesInventoryTransportApplication.grid.director',
            sortable: true,
            form: {
                type: 'entityModalSelect',
                modalMultiSelectedType: 'string'
                , entity: 'emAclUser'
            }
        },
        {
            key: 'purchaseApprover',
            label: 'label.sith.inventory.sithMesInventoryTransportApplication.grid.purchaseApprover',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'transOperator',
            label: 'label.sith.inventory.sithMesInventoryTransportApplication.grid.transOperator',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'actualOperator',
            label: 'label.sith.inventory.sithMesInventoryTransportApplication.grid.actualOperator',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'logManager',
            label: 'label.sith.inventory.sithMesInventoryTransportApplication.grid.logManager',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'logTransManager',
            label: 'label.sith.inventory.sithMesInventoryTransportApplication.grid.logTransManager',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'transportFrame',
            label: 'label.sith.inventory.sithMesInventoryTransportApplication.grid.transportFrame',
            sortable: true,
            form: {
                type: 'select',
                modalMultiSelectedType: 'string'
                , options: [
                    {value: '1', text: '框架内'},
                    {value: '2', text: '框架外'}
                ]
            }
        },
        {
            key: 'detailInformation',
            label: 'label.sith.inventory.sithMesInventoryTransportApplication.grid.detailInformation',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'prdOrderCode',
            label: 'label.sith.inventory.sithMesInventoryTransportApplication.grid.prdOrderCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'prdOperationCode',
            label: 'label.sith.inventory.sithMesInventoryTransportApplication.grid.prdOperationCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'operationDesc',
            label: 'label.sith.inventory.sithMesInventoryTransportApplication.grid.operationDesc',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'attachmentList',
            label: 'label.sith.inventory.sithMesInventoryTransportApplication.grid.attachmentList',
            sortable: true,
            isDetail: true,
            form: {
                type: 'emAttachment',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'isAsn',
            label: 'label.sith.inventory.sithMesInventoryTransportApplication.grid.isAsn',
            sortable: true,
            form: {
                type: 'boolean',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'remark',
            label: 'label.sith.inventory.sithMesInventoryTransportApplication.grid.remark',
            sortable: true,
            isDetail: true,
            form: {
                type: 'textarea',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'createdByName',
            label: 'label.sith.inventory.sithMesInventoryTransportApplication.grid.createdByName',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'statusName',
            label: 'label.sith.inventory.sithMesInventoryTransportApplication.grid.statusName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
    ])
}

const filter = {
    idFilter: '',
    idListFilter: [],
    statusFilter: '',
    workOrderCodeFilter: '',
    transTypeFilter: '',
    projectCodeFilter: '',
    materialDescFilter: '',
    materialCodeFilter: '',
    quantityFilter: '',
    unitFilter: '',
    weightFilter: '',
    lengthFilter: '',
    widthFilter: '',
    heightFilter: '',
    detailInformationFilter: '',
    wbsFilter: '',
    outsourcePrFilter: '',
    transReasonFilter: '',
    demandOriginatorFilter: '',
    demandDepartmentFilter: '',
    sourceStationFilter: '',
    sourceAddrFilter: '',
    sourcePhoneFilter: '',
    sourceContactFilter: '',
    destStationFilter: '',
    destAddrFilter: '',
    destPhoneFilter: '',
    destContactFilter: '',
    requiredTimeRteFilter: '',
    requiredTimeLteFilter: '',
    requirePackageFilter: '',
    transStartTimeRteFilter: '',
    transStartTimeLteFilter: '',
    transCompleteTimeRteFilter: '',
    transCompleteTimeLteFilter: '',
    vehicleTypeFilter: '',
    carNumberFilter: '',
    tonnageFilter: '',
    transPrFilter: '',
    transporterFilter: '',
    frameFilter: '',
    directorFilter: '',
    purchaseApproverFilter: '',
    transOperatorFilter: '',
    actualOperatorFilter: '',
    logManagerFilter: '',
    logTransManagerFilter: '',
    transportFrameFilter: '',
    settlementVehicleTypeFilter: '',
    prdOrderCodeFilter: '',
    prdOperationCodeFilter: '',
    operationDescFilter: '',
    isAsnFilter: '',
    workflowQueryTypeFilter: '',
    statusNameFilter: ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
    {
        key: 'idFilter',
        label: 'label.sith.inventory.sithMesInventoryTransportApplication.filter.id',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'statusFilter',
        label: 'label.sith.inventory.sithMesInventoryTransportApplication.filter.status',
        disabled: false,
        form: {
            type: 'entitySelect',
            modalMultiSelectedType: 'string'
            , entity: 'emActProcessStatus'
            , showLabelSelectOne: true
            , selectFilter: {processBusinessEntityFilter: 'SithMesInventoryTransportApplication', statusFilter: 1}
        }
    },
    {
        key: 'workOrderCodeFilter',
        label: 'label.sith.inventory.sithMesInventoryTransportApplication.filter.workOrderCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'transTypeFilter',
        label: 'label.sith.inventory.sithMesInventoryTransportApplication.filter.transType',
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '1', text: '内对外'},
                {value: '2', text: '内对内'},
                {value: '3', text: '汽车吊'},
                {value: '4', text: '外对外'},
                {value: '5', text: '外对内'}
            ]
        }
    },
    {
        key: 'projectCodeFilter',
        label: 'label.sith.inventory.sithMesInventoryTransportApplication.filter.projectCode',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesPrdProjectPlanPrp'
            , correspondingField: 'projectCode'
            , fieldsBindingByEntityModalSelected: '{"wbs":"wbsNumber"}'
        }
    },
    {
        key: 'materialDescFilter',
        label: 'label.sith.inventory.sithMesInventoryTransportApplication.filter.materialDesc',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialCodeFilter',
        label: 'label.sith.inventory.sithMesInventoryTransportApplication.filter.materialCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'quantityFilter',
        label: 'label.sith.inventory.sithMesInventoryTransportApplication.filter.quantity',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'unitFilter',
        label: 'label.sith.inventory.sithMesInventoryTransportApplication.filter.unit',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'weightFilter',
        label: 'label.sith.inventory.sithMesInventoryTransportApplication.filter.weight',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'lengthFilter',
        label: 'label.sith.inventory.sithMesInventoryTransportApplication.filter.length',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'widthFilter',
        label: 'label.sith.inventory.sithMesInventoryTransportApplication.filter.width',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'heightFilter',
        label: 'label.sith.inventory.sithMesInventoryTransportApplication.filter.height',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'wbsFilter',
        label: 'label.sith.inventory.sithMesInventoryTransportApplication.filter.wbs',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'outsourcePrFilter',
        label: 'label.sith.inventory.sithMesInventoryTransportApplication.filter.outsourcePr',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'transReasonFilter',
        label: 'label.sith.inventory.sithMesInventoryTransportApplication.filter.transReason',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'demandOriginatorFilter',
        label: 'label.sith.inventory.sithMesInventoryTransportApplication.filter.demandOriginator',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'name'
        }
    },
    {
        key: 'demandDepartmentFilter',
        label: 'label.sith.inventory.sithMesInventoryTransportApplication.filter.demandDepartment',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesMstLocation'
            , correspondingField: 'name'
        }
    },
    {
        key: 'sourceStationFilter',
        label: 'label.sith.inventory.sithMesInventoryTransportApplication.filter.sourceStation',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'sourceAddrFilter',
        label: 'label.sith.inventory.sithMesInventoryTransportApplication.filter.sourceAddr',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'sourcePhoneFilter',
        label: 'label.sith.inventory.sithMesInventoryTransportApplication.filter.sourcePhone',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'sourceContactFilter',
        label: 'label.sith.inventory.sithMesInventoryTransportApplication.filter.sourceContact',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'destStationFilter',
        label: 'label.sith.inventory.sithMesInventoryTransportApplication.filter.destStation',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'destAddrFilter',
        label: 'label.sith.inventory.sithMesInventoryTransportApplication.filter.destAddr',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'destPhoneFilter',
        label: 'label.sith.inventory.sithMesInventoryTransportApplication.filter.destPhone',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'destContactFilter',
        label: 'label.sith.inventory.sithMesInventoryTransportApplication.filter.destContact',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'requiredTimeRteFilter',
        label: 'label.sith.inventory.sithMesInventoryTransportApplication.filter.requiredTimeRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'requiredTimeLteFilter',
        label: 'label.sith.inventory.sithMesInventoryTransportApplication.filter.requiredTimeLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'requirePackageFilter',
        label: 'label.sith.inventory.sithMesInventoryTransportApplication.filter.requirePackage',
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'transStartTimeRteFilter',
        label: 'label.sith.inventory.sithMesInventoryTransportApplication.filter.transStartTimeRte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'transStartTimeLteFilter',
        label: 'label.sith.inventory.sithMesInventoryTransportApplication.filter.transStartTimeLte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'transCompleteTimeRteFilter',
        label: 'label.sith.inventory.sithMesInventoryTransportApplication.filter.transCompleteTimeRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'transCompleteTimeLteFilter',
        label: 'label.sith.inventory.sithMesInventoryTransportApplication.filter.transCompleteTimeLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'vehicleTypeFilter',
        label: 'label.sith.inventory.sithMesInventoryTransportApplication.filter.vehicleType',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'carNumberFilter',
        label: 'label.sith.inventory.sithMesInventoryTransportApplication.filter.carNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tonnageFilter',
        label: 'label.sith.inventory.sithMesInventoryTransportApplication.filter.tonnage',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'transPrFilter',
        label: 'label.sith.inventory.sithMesInventoryTransportApplication.filter.transPr',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'transporterFilter',
        label: 'label.sith.inventory.sithMesInventoryTransportApplication.filter.transporter',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'frameFilter',
        label: 'label.sith.inventory.sithMesInventoryTransportApplication.filter.frame',
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '1', text: '框架内'},
                {value: '2', text: '框架外'}
            ]
        }
    },
    {
        key: 'directorFilter',
        label: 'label.sith.inventory.sithMesInventoryTransportApplication.filter.director',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'name'
        }
    },
    {
        key: 'purchaseApproverFilter',
        label: 'label.sith.inventory.sithMesInventoryTransportApplication.filter.purchaseApprover',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'name'
        }
    },
    {
        key: 'transOperatorFilter',
        label: 'label.sith.inventory.sithMesInventoryTransportApplication.filter.transOperator',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'name'
        }
    },
    {
        key: 'actualOperatorFilter',
        label: 'label.sith.inventory.sithMesInventoryTransportApplication.filter.actualOperator',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'name'
        }
    },
    {
        key: 'logManagerFilter',
        label: 'label.sith.inventory.sithMesInventoryTransportApplication.filter.logManager',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'name'
        }
    },
    {
        key: 'logTransManagerFilter',
        label: 'label.sith.inventory.sithMesInventoryTransportApplication.filter.logTransManager',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'name'
        }
    },
    {
        key: 'transportFrameFilter',
        label: 'label.sith.inventory.sithMesInventoryTransportApplication.filter.transportFrame',
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '1', text: '框架内'},
                {value: '2', text: '框架外'}
            ]
        }
    },
    {
        key: 'settlementVehicleTypeFilter',
        label: 'label.sith.inventory.sithMesInventoryTransportApplication.filter.settlementVehicleType',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'prdOrderCodeFilter',
        label: 'label.sith.inventory.sithMesInventoryTransportApplication.filter.prdOrderCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'prdOperationCodeFilter',
        label: 'label.sith.inventory.sithMesInventoryTransportApplication.filter.prdOperationCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'operationDescFilter',
        label: 'label.sith.inventory.sithMesInventoryTransportApplication.filter.operationDesc',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'isAsnFilter',
        label: 'label.sith.inventory.sithMesInventoryTransportApplication.filter.isAsn',
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'statusNameFilter',
        label: 'label.sith.inventory.sithMesInventoryTransportApplication.filter.statusName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    }
];


const partsEntityConfigs = [
    {
        key: 'attachment',
        label: 'label.sith.inventory.sithMesInventoryTransportApplication.entity.attachment',
        sortable: true,
        disabled: false,
        form: {
            type: 'emAttachment',
            modalMultiSelectedType: 'string'
            , correspondingField: 'attachmentList'
        }
    }
]
const dn400EntityConfigs = [
    {
        key: 'attachment',
        label: 'label.sith.inventory.sithMesInventoryTransportApplication.entity.attachment',
        sortable: true,
        disabled: false,
        form: {
            type: 'emAttachment',
            modalMultiSelectedType: 'string'
            , correspondingField: 'attachmentList'
        }
    }
]
const entityFormConfigs = [
    {
        key: 'transType',
        label: 'label.sith.inventory.sithMesInventoryTransportApplication.entity.transType',
        sortable: true,
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '1', text: '内对外'},
                {value: '2', text: '内对内'},
                {value: '3', text: '汽车吊'},
                {value: '4', text: '外对外'},
                {value: '5', text: '外对内'}
            ]
        }
    },
    {
        key: 'projectCode',
        label: 'label.sith.inventory.sithMesInventoryTransportApplication.entity.projectCode',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesPrdProjectPlanPrp'
            , correspondingField: 'projectCode'
            , fieldsBindingByEntityModalSelected: '{"wbs":"wbsNumber"}'
        }
    },
    {
        key: 'materialDesc',
        label: 'label.sith.inventory.sithMesInventoryTransportApplication.entity.materialDesc',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialCode',
        label: 'label.sith.inventory.sithMesInventoryTransportApplication.entity.materialCode',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'quantity',
        label: 'label.sith.inventory.sithMesInventoryTransportApplication.entity.quantity',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'unit',
        label: 'label.sith.inventory.sithMesInventoryTransportApplication.entity.unit',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'weight',
        label: 'label.sith.inventory.sithMesInventoryTransportApplication.entity.weight',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'length',
        label: 'label.sith.inventory.sithMesInventoryTransportApplication.entity.length',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'width',
        label: 'label.sith.inventory.sithMesInventoryTransportApplication.entity.width',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'height',
        label: 'label.sith.inventory.sithMesInventoryTransportApplication.entity.height',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'detailInformation',
        label: 'label.sith.inventory.sithMesInventoryTransportApplication.entity.detailInformation',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'wbs',
        label: 'label.sith.inventory.sithMesInventoryTransportApplication.entity.wbs',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesPrdProjectPlanPrp'
            , correspondingField: 'wbsNumber'
            , fieldsBindingByEntityModalSelected: '{"projectCode":"projectCode"}'
        }
    },
    {
        key: 'outsourcePr',
        label: 'label.sith.inventory.sithMesInventoryTransportApplication.entity.outsourcePr',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'transReason',
        label: 'label.sith.inventory.sithMesInventoryTransportApplication.entity.transReason',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'demandOriginator',
        label: 'label.sith.inventory.sithMesInventoryTransportApplication.entity.demandOriginator',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'name'
        }
    },
    {
        key: 'demandDepartment',
        label: 'label.sith.inventory.sithMesInventoryTransportApplication.entity.demandDepartment',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesMstLocation'
            , correspondingField: 'name'
        }
    },
    {
        key: 'sourceStation',
        label: 'label.sith.inventory.sithMesInventoryTransportApplication.entity.sourceStation',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'sourceAddr',
        label: 'label.sith.inventory.sithMesInventoryTransportApplication.entity.sourceAddr',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'sourcePhone',
        label: 'label.sith.inventory.sithMesInventoryTransportApplication.entity.sourcePhone',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'sourceContact',
        label: 'label.sith.inventory.sithMesInventoryTransportApplication.entity.sourceContact',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'destStation',
        label: 'label.sith.inventory.sithMesInventoryTransportApplication.entity.destStation',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'destAddr',
        label: 'label.sith.inventory.sithMesInventoryTransportApplication.entity.destAddr',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'destPhone',
        label: 'label.sith.inventory.sithMesInventoryTransportApplication.entity.destPhone',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'destContact',
        label: 'label.sith.inventory.sithMesInventoryTransportApplication.entity.destContact',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'requiredTime',
        label: 'label.sith.inventory.sithMesInventoryTransportApplication.entity.requiredTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'requirePackage',
        label: 'label.sith.inventory.sithMesInventoryTransportApplication.entity.requirePackage',
        sortable: true,
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'transStartTime',
        label: 'label.sith.inventory.sithMesInventoryTransportApplication.entity.transStartTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'transCompleteTime',
        label: 'label.sith.inventory.sithMesInventoryTransportApplication.entity.transCompleteTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'vehicleType',
        label: 'label.sith.inventory.sithMesInventoryTransportApplication.entity.vehicleType',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'carNumber',
        label: 'label.sith.inventory.sithMesInventoryTransportApplication.entity.carNumber',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tonnage',
        label: 'label.sith.inventory.sithMesInventoryTransportApplication.entity.tonnage',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'transPr',
        label: 'label.sith.inventory.sithMesInventoryTransportApplication.entity.transPr',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'transporter',
        label: 'label.sith.inventory.sithMesInventoryTransportApplication.entity.transporter',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'frame',
        label: 'label.sith.inventory.sithMesInventoryTransportApplication.entity.frame',
        sortable: true,
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '1', text: '框架内'},
                {value: '2', text: '框架外'}
            ]
        }
    },
    {
        key: 'transportFrame',
        label: 'label.sith.inventory.sithMesInventoryTransportApplication.entity.transportFrame',
        sortable: true,
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '1', text: '框架内'},
                {value: '2', text: '框架外'}
            ]
        }
    },
    {
        key: 'settlementVehicleType',
        label: 'label.sith.inventory.sithMesInventoryTransportApplication.entity.settlementVehicleType',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'prdOrderCode',
        label: 'label.sith.inventory.sithMesInventoryTransportApplication.entity.prdOrderCode',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'prdOperationCode',
        label: 'label.sith.inventory.sithMesInventoryTransportApplication.entity.prdOperationCode',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'operationDesc',
        label: 'label.sith.inventory.sithMesInventoryTransportApplication.entity.operationDesc',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'isAsn',
        label: 'label.sith.inventory.sithMesInventoryTransportApplication.entity.isAsn',
        sortable: true,
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'remark',
        label: 'label.sith.inventory.sithMesInventoryTransportApplication.entity.remark',
        sortable: true,
        disabled: false,
        form: {
            type: 'textarea',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'attachmentList',
        label: 'label.sith.inventory.sithMesInventoryTransportApplication.entity.attachment',
        sortable: false,
        disabled: false,
        form: {
            type: 'emAttachment',
            modalMultiSelectedType: 'string'
            , correspondingField: 'attachment'
        }
    }
]
const inspectionEntityConfigs = [
    {
        key: 'attachment',
        label: 'label.sith.inventory.sithMesInventoryTransportApplication.entity.attachment',
        sortable: true,
        disabled: false,
        form: {
            type: 'emAttachment',
            modalMultiSelectedType: 'string'
            , correspondingField: 'attachmentList'
        }
    }
]
const orderEntityConfigs = [
    {
        key: 'attachment',
        label: 'label.sith.inventory.sithMesInventoryTransportApplication.entity.attachment',
        sortable: true,
        disabled: false,
        form: {
            type: 'emAttachment',
            modalMultiSelectedType: 'string'
            , correspondingField: 'attachmentList'
        }
    }
]

export {
    SithMesInventoryTransportApplication, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
    , filterConfigs
    , partsEntityConfigs, dn400EntityConfigs, inspectionEntityConfigs, orderEntityConfigs

}
